module.exports = __webpack_public_path__ + "static/media/img-producto-tuberia.abe46147.png";